export default __webpack_public_path__ + "static/media/6.2d5a3f0a.png";